import {StoragePromoCodeRepository} from '@domain/model/PromoCode/StoragePromoCodeRepository';

const SetPromoBannerFlag =
  (repository: StoragePromoCodeRepository) =>
  (value: boolean): void => {
    return repository.setPromoBannerFlag(value);
  };

export {SetPromoBannerFlag};
